import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FeedbackDTO } from "@shared/model/auctioneer.model";
import { RatingData } from "@shared/services/alert-message/alert-message.model";
import { AuctionService } from "@shared/services/auction/auction.service";
import { ShowcaseService } from "@shared/services/showcase/showcase.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";
import { RatingChangeEvent } from "angular-star-rating";

@Component({
	selector: "app-rating-selector",
	templateUrl: "./rating-selector.component.html",
	styleUrl: "./rating-selector.component.scss",
	standalone: false
})
export class RatingSelectorComponent {
	public rated: boolean;

	constructor(
		private auctionService: AuctionService,
		private showcaseService: ShowcaseService,
		public utils: ClickarUtilsService,
		public dialogRef: MatDialogRef<RatingSelectorComponent>,
		@Inject(MAT_DIALOG_DATA) public data: RatingData
	) { }

	ratingChange(event: RatingChangeEvent) {
		this.data.rating = event.rating;
		this.rated = true;
	}

	private readonly commonMethod = value => {
		const a = new RatingData();
		a.rating = this.data.rating;
		a.idFeedback = value;
		this.dialogRef.close(a);
	};

	vote() {
		if (this.rated) {
			const feedback = new FeedbackDTO();
			feedback.rating = this.data.rating;
			feedback.idAuctioneer = this.data.idAuctioneer;
			if (!this.utils.isNullOrUndefined(this.data.idAuction)) {
				this.auctionService.auctionFeedbackPOST(feedback, this.data.idAuction).subscribe(this.commonMethod);
			} else
				if (!this.utils.isNullOrUndefined(this.data.idLot)) {
					this.showcaseService.showcaseFeedbackUsingPOST(feedback, this.data.idLot).subscribe(this.commonMethod);
				}
		}
	}
}
